import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { GetStateStorage } from 'common/storage';
import { MailProDialog } from 'views/Pma/MailPro/components/MailProDialog/MailProDialog';
import { MailProDialogHeader } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogHeader';
import { MailProDialogBody } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogBody';
import MailProButton from 'views/Pma/MailPro/components/UI/MailProButton';

const useStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '24px 16px',
    gap: '12px',
  },
  button: {
    marginTop: '12px',
  },
});

// Self-contained: reads userData.isNewLegalContractAvailable itself and
// renders nothing when it's not true, so callers (e.g. Home) just drop in
// <LegalContractChecker /> with no props/state of their own to manage.
// No onClose/close-button/escape/backdrop path is wired up anywhere here -
// the dialog is non-dismissable by construction, not just by convention.
const LegalContractChecker = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const storageData = GetStateStorage();
  const userData = (storageData || {}).userData || {};

  if (!userData.isNewLegalContractAvailable) {
    return null;
  }

  const agentFirstName = userData.listgenUserFirstName || '';

  return (
    <MailProDialog
      open
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="legal-contract-update-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <MailProDialogHeader>
        <Typography variant="h3" style={{ color: 'white', fontWeight: 600 }}>
          Legal Terms Update
        </Typography>
      </MailProDialogHeader>
      <MailProDialogBody>
        <div className={classes.body}>
          <Typography variant="body1" style={{ fontSize: '18px' }}>Greetings {agentFirstName},</Typography>
          <Typography variant="body1" style={{ fontSize: '18px' }}>
            We&apos;ve made a minor update to our Legal Terms.
          </Typography>
          <Typography variant="body1" style={{ fontSize: '18px' }}>
            Please take a moment to review and sign the Agreement.
          </Typography>
          <MailProButton
            label="CLICK HERE TO CONTINUE"
            variant="filled"
            onClick={() => navigate('/legal')}
            customStyle={{ marginTop: '12px' }}
          />
        </div>
      </MailProDialogBody>
    </MailProDialog>
  );
};

export default LegalContractChecker;
